import React from 'react'
import { Broadcast } from 'react-broadcast'
import { Query } from 'react-apollo'
import graphqlQuery from 'graphs/queries/Product.graphql'

const ProductProvider = ({ children, ...rest }) => (
  <Query query={graphqlQuery} {...rest}>
    {({ loading, data: { product } }) => (
      <Broadcast channel="product" value={{ loading, product }}>
        {children}
      </Broadcast>
    )}
  </Query>
)

export default ProductProvider



// WEBPACK FOOTER //
// ./src/components/Product/Provider.js